import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function Services() {
  const packages = [
    {
      name: "Foundations of Wellness",
      price: "$495",
      features: [
        "1:1 60-Minute Coaching Session",
        "Personalized Wellness Roadmap",
        "Access to Nouriv Client Dashboard",
        "Intro Resource Library",
        "Session Recording + Replay",
      ],
      cta: "Perfect for those starting their health journey with focused support.",
    },
    {
      name: "Total Health Transformation",
      price: "$1,495",
      features: [
        "6-Week Personalized Coaching Program",
        "Weekly Zoom Sessions (Recorded)",
        "Meal & Movement Planning",
        "Private Messaging via Nouriv",
        "Progress Tracker + Homework Assignments",
        "Full Resource Library Access",
      ],
      cta: "Ideal for clients ready to commit to lasting change and accountability.",
    },
    {
      name: "Premium Wellness Experience",
      price: "$3,200",
      features: [
        "12 Weeks of High-Touch Coaching",
        "Weekly 1:1 Calls + Midweek Check-ins",
        "Customized Resource Hub in Nouriv",
        "Client Notes, Milestone Tracking, & Messaging",
        "Video Replays, Badge Rewards, & Office Hours",
        "Support Ticketing for Ongoing Help",
        "Priority Booking + Bonus Session",
      ],
      cta: "Designed for long-term support and deep transformation with all the tools.",
    },
  ];

  return (
    <main className="bg-white text-[#1A3C34] font-sans">
      <Navbar />

      {/* Header */}
      <section className="py-24 px-6 text-center bg-[#f1f4ec]">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">
          Coaching <span className="italic text-[#F9C93F]">Packages</span> Designed to Support Your Wellness Journey
        </h1>
        <p className="text-lg text-gray-700 max-w-3xl mx-auto">
          Whether you're just beginning or ready to fully transform, these programs are built to meet you where you are — and walk with you every step of the way.
        </p>
      </section>

      {/* Services Grid */}
      <section className="max-w-6xl mx-auto px-6 py-20 grid md:grid-cols-3 gap-10">
        {packages.map((pkg, idx) => (
          <div
            key={idx}
            className="bg-[#fdfdfb] rounded-2xl shadow-xl border border-[#e4e4e4] p-8 flex flex-col justify-between hover:shadow-2xl transition-shadow duration-300"
          >
            <div>
              <h2 className="text-2xl font-bold italic mb-2">{pkg.name}</h2>
              <p className="text-3xl font-bold mb-6">{pkg.price}</p>
              <ul className="space-y-2 text-sm text-gray-700 mb-6">
                {pkg.features.map((feature, i) => (
                  <li key={i} className="flex items-start">
                    <span className="mr-2 text-[#F9C93F]">✔</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="italic text-gray-600 mb-4">{pkg.cta}</p>
              <a
                href="/contact"
                className="inline-block bg-[#F9C93F] border border-black text-black font-semibold px-6 py-2 rounded-full hover:bg-black hover:text-white transition-colors duration-300"
              >
                Book This Package
              </a>
            </div>
          </div>
        ))}
      </section>

      {/* Optional CTA Banner */}
      <section className="bg-[#f1f4ec] py-16 text-center px-6">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Not sure which program is right for you?
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Schedule a free consultation and let’s map out the path that fits your goals and lifestyle.
        </p>
        <a
          href="/contact"
          className="bg-[#1A3C34] text-white px-8 py-3 rounded-full font-semibold hover:bg-[#2e5d50] transition-colors duration-300 shadow-md"
        >
          Schedule Your Free Call
        </a>
      </section>

      <Footer />
    </main>
  );
}
